module.exports = __webpack_public_path__ + "img/xinwen.a9bf4866.png";